type HotelGoodPriceProduct = {
  __key: string
  index: number
  hotelCard?: {
    searchHotelId?: string | number
    pricing?: {
      priceAfterHotelDiscount?: number | string
    }
  }
  [key: string]: unknown
}

/**
 * Flatten deal payloads into unique hotel cards (cheapest wins),
 * with stable unique React keys.
 */
export const flattenHotelGoodPriceProducts = (data: any[] = []): HotelGoodPriceProduct[] => {
  const flattened = (Array.isArray(data) ? data : []).flatMap((deal, dealIndex) => {
    const products = Array.isArray(deal?.payload) ? deal.payload : []

    return products.map((product: any, productIndex: number) => ({
      ...product,
      index: dealIndex,
      // Always include dealIndex + productIndex — searchHotelId alone can duplicate across deals.
      __key: `${deal?.id ?? "deal"}-${dealIndex}-${product?.hotelCard?.searchHotelId ?? "hotel"}-${productIndex}`,
    }))
  })

  // Keep cheapest offer per hotel so carousel/list keys stay unique by hotel too.
  const cheapestByHotel = new Map<string, HotelGoodPriceProduct>()

  for (const product of flattened) {
    const hotelId = String(product?.hotelCard?.searchHotelId ?? product.__key)
    const price = Number(product?.hotelCard?.pricing?.priceAfterHotelDiscount ?? Number.MAX_SAFE_INTEGER)
    const existing = cheapestByHotel.get(hotelId)

    if (!existing) {
      cheapestByHotel.set(hotelId, product)
      continue
    }

    const existingPrice = Number(
      existing?.hotelCard?.pricing?.priceAfterHotelDiscount ?? Number.MAX_SAFE_INTEGER,
    )
    if (price < existingPrice) {
      cheapestByHotel.set(hotelId, product)
    }
  }

  return Array.from(cheapestByHotel.values()).sort((a, b) => {
    const aPrice = Number(a?.hotelCard?.pricing?.priceAfterHotelDiscount ?? Number.MAX_SAFE_INTEGER)
    const bPrice = Number(b?.hotelCard?.pricing?.priceAfterHotelDiscount ?? Number.MAX_SAFE_INTEGER)
    return aPrice - bPrice
  })
}
